import React from "react";
import { setImgTagWidth, setImgTagHeight } from "../../utils/utils";

const TextOverlayOnImage = ({textOverlay, size, type}) => {

  return (
    <div className={type} style={{ maxHeight: setImgTagHeight(size) + 'px', maxWidth: setImgTagWidth(size) + 'px' }}>
      { textOverlay }
    </div>
  )
}

export default TextOverlayOnImage;